import * as Counter from './Counter.css';

export default {
	Counter
};
